import { render, staticRenderFns } from "./OrderConnection.vue?vue&type=template&id=224346f3&scoped=true"
import script from "./OrderConnection.vue?vue&type=script&lang=js"
export * from "./OrderConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224346f3",
  null
  
)

export default component.exports